/**
 * Author(s) : Jerry Oswin
 * Purpose : This is a Redirect Component to redirect to home when invalid Url is entered.
 */
import { Navigate } from 'react-router-dom';
import { HOME_ROUTE } from '../../constants';

function RedirectComponent() {
    // Redirect to home for any invalid Url
    return <Navigate to={{pathname: HOME_ROUTE}} />
}
 
export default RedirectComponent;